export default "/assets/images/mila-air-3-alt.16dc87c88176fa15.webp";